

<app-header></app-header>
<app-profile-header></app-profile-header>
<app-right-side></app-right-side>
<div class="container">
    <div class="row">
        <div *ngIf="followers" class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" style="top:-100px">
            <div class="ui-block responsive-flex" style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                <div class="ui-block-title">
                    <div class="h6 title"> Totals Following ( {{followers.length}} ) </div>
                    <form class="w-search">
                        <div class="form-group with-button">
                            <input class="form-control" type="text" name="search" [(ngModel)]="searchText"
                                autocomplete="off" [ngModelOptions]="{standalone: true}" placeholder="Search">
                            <button>
                                <svg class="olymp-magnifying-glass-icon">
                                    <use
                                        xlink:href="../../../assets/svg-icons/sprites/icons.svg#olymp-magnifying-glass-icon">
                                    </use>
                                </svg>
                            </button>
                        </div>
                    </form>
                    <!-- <a  href="javascript:void(0);" class="more"><svg class="olymp-three-dots-icon">
							<use xlink:href="../../../assets/svg-icons/sprites/icons.svg#olymp-three-dots-icon"></use>
						</svg></a> -->
                </div>
            </div>
        </div>
        <div *ngIf="followers.length === 0" class="ui-block-title" style="top:-100px">
            <h6 class="title" style="text-align: center; color: var(--text-color);">No Followers Found!
            </h6>

        </div>

    </div>
</div>


<!-- Friends -->

<div class="container" style="top:-100px">
    <div class="row">
        <div *ngFor="let follower of followers | filter:searchText"
            class="col col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12" style="top:-100px">
            <div class="ui-block" style="background-color: var(--backgroundpost-color); color: var(--text-color);">

                <!-- Friend Item -->

                <div class="friend-item">
                    <div class="friend-header-thumb">
                        <img alt="friend" src="../../../assets/img/small-cover.webp" width="318" height="122">
                        <!-- <img *ngIf="follower.banner" alt="friend" [src]="follower.banner" width="318" height="122"> -->
                    </div>

                    <div class="friend-item-content">

                        <div class="more">
                            <a (click)="openFollowerDeleteModal(followerDeleteModal, follower)"> <i class="fa fa-trash"
                                    aria-hidden="true"></i> </a>
                        </div>
                        <div class="friend-avatar">
                            <div class="author-thumb">
                                <a routerLink="/friend-about" [queryParams]="{'id': follower.user.id}">
                                    <img *ngIf="!follower.user.avatar" alt="author" src="../../../assets/img/user.jpg"
                                        width="100" height="100"
                                        onerror="this.onerror=null;this.src='../../../assets/img/author-main1.webp';"
                                        style="width: 100px; height: 100px;">

                                    <img *ngIf="follower.user.avatar" alt="author" [src]="follower.user.avatar" width="100"
                                        height="100"
                                        onerror="this.onerror=null;this.src='../../../assets/img/author-main1.webp';"
                                        style="width: 100px; height: 100px;">
                                </a>
                            </div>
                            <div class="author-content">
                                <a routerLink="/friend-about" [queryParams]="{'id': follower.id}"
                                    class="h5 author-name1">{{ follower.user.fullName | titlecase}}</a>
                                <div *ngIf="follower.user.countryName" class="country">
                                    {{ follower.user.countryName | titlecase}}</div>
                                <div *ngIf="!follower.user.countryName" class="country">{{ 'Country Name'}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- ... end Friend Item -->
            </div>
        </div>


    </div>
</div>

<!-- ... end Friends -->


<!-- Delete Modal Friend -->
<div class="modal fade" bsModal #followerDeleteModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1"
    role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Delete Follower</h5>
                <button type="button" class="close" (click)="followerDeleteModal.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <label>Are you Sure you want to delete Follower</label>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="followerDeleteModal.hide()">No</button>
                <button type="button" class="btn btn-danger" (click)="deleteFollower(followerDeleteModal)">Yes</button>
            </div>
        </div>
    </div>
</div>
<!--  Delete Modal Friend  -->